import { BlankHeader, ContactForm } from '../../components/website/Utility';
import { NavLink } from 'react-router-dom';
import '../../assets/css/views/pricing.css';

export default function PublicPricing() {
    const features = [
        'Unlimited Orders',
        'VIP Program',
        'Custom Giveaways',
        'Timed Promotions',
        'Dedicated Loyalty Page',
        'Dynamic Shopify Sections',
        'Unlimited Integrations'
    ];

  return (
    <>
      <BlankHeader heading="PLANS AND PRICING" />   
      <div className="pricing__section">
        <div className="pricing__header">
            <h2 className="pricing-details__heading">100% Free for a Limited Time</h2>
            <p className="pricing-details__subheading">Amplify Loyalty will be a paid app in the future but you can get access to all features at no cost right now. Create your account now and start building customer loyalty!</p>
        </div>
        <div className="pricing__plans-container">
            <div className="pricing__plan">
                <div className="pricing__plan-header">
                    <h3 className="pricing__plan-name">Free</h3>
                    <div className="pricing__plan-price">
                        $0
                        <span>/mo</span>
                    </div>
                </div>
                <ul className="pricing__plan-features">
                    {features.map((feature) => (
                        <li key={feature} className="pricing__plan-feature">
                            <i className="fa-solid fa-check pricing__plan-icon"></i> {feature}
                        </li>
                    ))}
                </ul>
                <div className="pricing__plan-button-container">
                    <NavLink to="/sign-up" className="pricing__plan-button gradient btn">
                        Get Started
                    </NavLink>
                </div>
            </div>
        </div>
      </div>
      <ContactForm heading="HAVE ANY QUESTIONS?" />
    </>
  )
}